export class SelectItemOption
{
    label: string;
    value: any;
    extraInfo: any;

    constructor(label: string, value: any, extraInfo = null)
    {
        this.label = label;
        this.value = value;
        this.extraInfo = extraInfo;
    }
}
